var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.forceOffline},[_vm._m(0),_c('main',[_c('p',[_vm._v("网络波动，请重新连接")]),_c('button',{staticClass:"yw-btn yw-btn-primary",on:{"click":_vm.reload}},[_vm._v("重新登录")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('span',[_vm._v("提示")])])
}]

export { render, staticRenderFns }